module.exports = __webpack_public_path__ + "static/media/certificate (1).524b7020.svg";